import { hasSSLCertificate } from '@pm2/api';
import { Link } from '@provider/navigation';
import { jsx } from 'react/jsx-runtime';

function CardLink({
  hostname,
  path,
  layout,
  isFocused,
  ...anchorProps
}) {
  const protocol = hasSSLCertificate(hostname) ? "https://" : "http://";
  return /*#__PURE__*/jsx(Link, {
    ...anchorProps,
    ref: anchorProps.ref,
    href: `${protocol}${hostname}${path}`,
    tabIndex: layout === "slider" && !isFocused ? -1 : undefined
  });
}

export { CardLink };
//# sourceMappingURL=card-link.js.map
